App.AuthLogoutRoute = Ember.Route.extend
  session: Em.inject.service()

  beforeModel : ->
    @get('session').endSession()
    @transitionTo 'index'